import React, { useState } from 'react';
import { shape, string, number } from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { map } from 'lodash';
import withProjectSidebar from '../../../components/with-project-sidebar';
import Tabs from '../../../constants/tabs';
import TreeTestAnalytics from './tree-test';

import {
  Dropdown,
} from './styles';
import EmptyResult from '../components/empty-result';
import EmptyResultSegment from '../components/empty-segment';

const ProjectAnalyticsTreeTest = (props) => {
  const {
    project,
  } = props;
  const [segmentSelected, setSegmentSelected] = useState('all');

  const {
    receivedTests, status, testType, id,
  } = project;

  // FIXME: the card sort and survey are different from the tree_test
  // WHY? I DONT KNOW. But I know the logic is:
  // Tree test analytics only show up when it reaches the maximum number of participants
  // but card sort and surveys analytics show up even if
  // they don't reach the max number of participants.
  // It happens because of the receivedTests field in the API
  // super nice logic
  if (receivedTests === 0 && status !== 'done' && segmentSelected === 'all') {
    return (
      <EmptyResult testType="tree_test" />
    );
  }

  if (receivedTests === 0 && segmentSelected !== 'all') {
    return (
      <EmptyResultSegment />
    );
  }

  const dropdownOptions = [
    { key: 1, text: 'All audience segments', value: 'all' },
    ...map(project.segments, (segment) => ({
      key: segment.id,
      text: segment.name,
      value: segment.id,
    })),
  ];

  return (
    <>
      {project.segments.length > 1 && (
        <Dropdown
          placeholder="Select one segment"
          fluid
          selection
          value={segmentSelected}
          defaultValue="all"
          onChange={(event, data) => setSegmentSelected(data.value)}
          options={dropdownOptions}
        />
      )}
      <TreeTestAnalytics
        projectId={id}
        projectTestType={testType}
        segmentId={segmentSelected !== 'all' ? segmentSelected : undefined}
      />
    </>
  );
};

ProjectAnalyticsTreeTest.propTypes = {
  project: shape({
    id: string,
    status: string,
    segments: shape(),
    receivedTests: number,
    testType: string,
  }).isRequired,
};

export default compose(
  withRouter,
  withProjectSidebar({ selectedTab: Tabs.PROJECT }),
)(ProjectAnalyticsTreeTest);
